import React, { useState, useEffect } from 'react'
import dayjs from 'dayjs'
import { useTranslate, useNotify, useRefresh } from 'react-admin'
import { Skeleton, Box, Typography, Grid } from '@mui/material'
import { ShowElement } from 'src/components/uiElements/CRUD/ShowElement'
import LoadingButton from '@mui/lab/LoadingButton'
import { ShowCard, CompleteSideCard } from 'src/components/uiElements/cards/ShowCard'
import EditIcon from '@mui/icons-material/Edit'
import AddIcon from '@mui/icons-material/Add'
import PersonIcon from '@mui/icons-material/Person'
import { blue } from 'src/assets/colors'
import { paxServices } from 'src/services/reservation/pax/pax.service'
import { ModalPassenger } from 'src/components/pages/sales/reservation/logic/modals/ModalPassenger'
import { isDateISO } from 'src/helper/isDateISO'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
import { HasPermission, hasPermissionFunction } from 'src/helper/HasPermission'
import { WrapperCardId } from 'src/components/pages/sales/reservation/logic/common/WrapperCardId'
import { useCardLoading } from 'src/components/pages/sales/reservation/context/CardLoadingContext'
import { SwitchInput } from 'src/components/uiElements/fields/SwitchInput'
import { PERMISSION_CREATE, PERMISSION_EDIT } from 'src/helper/Permission'
import { completeDateDigitsPassengers } from '../../helper/completeDateDigitsPassengers'

export const PassengerReservation = ({ passengers, editMode = false, ...props }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const refresh = useRefresh()
  const [titular, setTitular] = useState(null)
  const [currentPassanger, setCurrentPassanger] = useState(null)
  const [updatePassengerLoading, setupdatePassengerLoadingg] = useState(false)
  const [openPasaggerModal, setOpenPasaggerModal] = useState(false)
  const { setCardLoading } = useCardLoading()
  useEffect(() => {
    if (passengers?.length) {
      const titular_passanger = passengers.filter((pass) => pass?.is_titular === true)
      if (titular_passanger && titular_passanger.length === 1) {
        setTitular(titular_passanger[0].id)
      }
    }
  }, [passengers])

  const handleChange = (passenger) => {
    if (!passenger.is_titular || !titular) {
      updateOldTitular()
      setTitular(passenger.id)
      updateTitutarService(passenger) // new titular
    }
    customAwait([refresh])
  }

  const onSuccess = (name, isTitular) => {
    notify(`ra.notification.${isTitular ? 'updated_success_titular' : 'updated_success_passenger'}`, {
      type: 'success',
      messageArgs: { passenger: name },
    })
  }

  const onError = (name) => {
    notify('ra.notification.updated_error_titular', {
      type: 'error',
      messageArgs: { passenger: name },
    })
  }

  const updateOldTitular = () => {
    const currentTitutar = passengers.find((pass) => pass.is_titular === true)
    if (currentTitutar) {
      updateTitutarService(currentTitutar, false) // old titular
    }
  }

  const updateTitutarService = async (passenger, state = true) => {
    try {
      const update_titular = {
        ...passenger,
        is_titular: state,
      }
      let updatePassenger = await paxServices.updatePax(passenger.id, update_titular)
      if (updatePassenger && state) {
        onSuccess(`${updatePassenger.name} ${updatePassenger.surname}`, true)
        props.onUpdatePassenger && props.onUpdatePassenger(updatePassenger)
      }
    } catch (error) {
      onError(`${passenger.name} ${passenger.surname}`)
    } finally {
      customAwait([refresh])
    }
  }

  const onUpdatePassenger = async (passenger, cardId) => {
    try {
      setupdatePassengerLoadingg(true)
      let date = passenger?.birth_date
      if (isDateISO(date)) {
        date = new Date(date).toISOString().split('T')[0]
      }
      let updatePassenger = await paxServices.updatePaxToItems({
        ...passenger,
        birth_date: date,
      })
      if (updatePassenger) {
        onSuccess(`${updatePassenger.name} ${updatePassenger.surname}`, false)
        props.onUpdatePassenger && props.onUpdatePassenger(updatePassenger)
      }
    } catch (error) {
      onError(`${passenger.name} ${passenger.surname}`)
    } finally {
      setupdatePassengerLoadingg(false)
      setOpenPasaggerModal(false)
      setCardLoading(cardId, true)
      customAwait([refresh])
    }
  }

  const transformPassenger = (listpax) => {
    if (Array.isArray(listpax) && listpax.length !== 0) {
      let copy = [...listpax]
      return copy.map((passanger, index) => {
        let newObject = {
          position: index + 1,
          birth_date: passanger.birth_date,
          is_titular: passanger.is_titular,
          id: passanger.id,
          name: passanger.name,
          surname: passanger.surname,
          type: passanger.type,
          extra: passanger.extra,
          data: {
            name: passanger.name,
            surname: passanger.surname,
            ...copy[index],
            document: passanger?.document_type_relation?.short_name,
          },
        }
        delete newObject.data.document_type_relation
        delete newObject.data.external_id
        delete newObject.data.is_titular
        delete newObject.data.extra
        delete newObject.data.document_type_id
        delete newObject.data.age
        delete newObject.data.id
        delete newObject.data.item_relation
        delete newObject.data.pax_item_relation
        return newObject
      })
    }
    return []
  }

  return (
    <>
      <Box display={'flex'} justifyContent={'space-between'} padding={'15px 20px'}>
        <Typography variant='h5' color={blue} fontWeight={'800'}>
          {translate('ra.title.passenger')}
        </Typography>
        <HasPermission permission={PERMISSION_CREATE} resource={'pax'}>
          <LoadingButton
            variant='contained'
            onClick={props.onClickButtonOpenPasaggerModal}
            sx={{ width: '20%' }}
            endIcon={<AddIcon />}
            size='small'
          >
            {translate('ra.title.add_passenger')}
          </LoadingButton>
        </HasPermission>
      </Box>
      <WrapperCardId>
        <ModalPassenger
          open={openPasaggerModal}
          handleClose={() => {
            setOpenPasaggerModal(false)
            setCurrentPassanger(null)
          }}
          item={props?.item || []}
          titleModal={translate('ra.title.update_passenger')}
          onSubmit={(passanger, cardId) => onUpdatePassenger(passanger, cardId)}
          loadingButton={updatePassengerLoading}
          record={currentPassanger}
        />
        {props.isLoading ? (
          <Skeleton variant='rectangular' width={'100%'} height={100} />
        ) : !passengers || passengers.length === 0 ? (
          <Typography padding={'20px'} variant='h7'>
            {translate('ra.message.no_passenger')}
          </Typography>
        ) : (
          transformPassenger(passengers).map((passenger, index) => (
            <ShowCard
              key={index}
              iconHeader={<PersonIcon />}
              optionHeigth='general'
              title={`${passenger.name} ${passenger.surname} ${passenger.type ? `(${passenger.type})` : ''}`}
              posTitle={
                passenger.id === titular ? (
                  <Typography
                    sx={{
                      padding: '5px 5px 5px 5px',
                      color: 'white',
                      backgroundColor: 'red',
                      borderRadius: '5px',
                      marginLeft: '10px',
                    }}
                  >
                    {translate('ra.field.holder')}
                  </Typography>
                ) : undefined
              }
              preActionButton={
                <HasPermission permission={PERMISSION_EDIT} resource={'pax'}>
                  <Box display='flex' justifyContent={'flex-end'} paddingX={'20px'} alignItems={'center'}>
                    <Typography>{translate('ra.field.holder')}:</Typography>
                    <SwitchInput
                      value={titular === passenger.id}
                      onChange={() => {
                        const passengerAux = passengers?.find((pass) => pass.id === passenger.id)
                        handleChange(passengerAux)
                      }}
                      style={{ paddingLeft: 9 }}
                    />
                  </Box>
                </HasPermission>
              }
              actionButtonText={editMode ? null : translate('ra.title.update_passenger')}
              actionButtonIcon={!editMode && <EditIcon />}
              onClickButton={
                editMode
                  ? null
                  : hasPermissionFunction('pax', PERMISSION_EDIT)
                  ? () => {
                      const passanger = passengers?.filter((pass) => pass.id === passenger.id)
                      setCurrentPassanger(passanger?.[0])
                      setOpenPasaggerModal(true)
                    }
                  : null
              }
            >
              <CompleteSideCard>
                <Grid container spacing={2}>
                  {Object.keys(passenger.data).map((key) => (
                    <Grid item xs={5} md={4} lg={3} key={key}>
                      <ShowElement
                        style={{ padding: '5px 15px 5px 15px' }}
                        data={
                          (key.includes('date') && key !== 'birth_date') ? 
                          completeDateDigitsPassengers(passenger.data?.[key]) :
                          passenger.data?.[key]
                        }
                        label={translate(`ra.field.${key}`)}
                        date={key.includes('date')}
                      />
                    </Grid>
                  ))}
                  {passenger.extra?.expirationDate && <Grid item xs={5} md={4} lg={3} key={'expirationDate'}>
                    <ShowElement
                      style={{ padding: '5px 15px 5px 15px' }}
                      data={completeDateDigitsPassengers(passenger.extra?.expirationDate)}
                      label={translate('ra.field.expiration_date')}
                      date={true}
                    />
                  </Grid>}
                </Grid>
              </CompleteSideCard>
            </ShowCard>
          ))
        )}
      </WrapperCardId>
    </>
  )
}
